import React from "react";
import project1 from "../assets/project1/project1.png";

const Projects = ({ lenguaje }) => {
  const showProject = (projectNumber) => {
    document.querySelector(".projectPopUp").style.setProperty("opacity", "1");

    document.querySelector(".projectPopUp").style.setProperty("z-index", "100");
  };
  return (
    <div className="projects">
      <h1>{lenguaje == "eng" ? "PROJECTS" : "PROYECTOS"}</h1>
      <div className="coolcircle"></div>
      <div className="container-projects">
        <div className="card" style={{ "--i": -1 }}>
          <div className="content" style={{ "--j": 1 }}>
            <div style={{ display: "flex", gap: "20px" }}>
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Laravel.svg/1200px-Laravel.svg.png"
                alt="laravel logo"
                style={{ width: "30px" }}
              />

              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Postgresql_elephant.svg/1200px-Postgresql_elephant.svg.png"
                alt="laravel logo"
                style={{ width: "30px" }}
              />
            </div>
            <a href="http://admin-hospital-tomas.herokuapp.com/">
              <h3 style={{ fontSize: "1.2rem" }}>
                {lenguaje == "eng"
                  ? "Hospital Management"
                  : "Administrador de Hospital"}
              </h3>
            </a>
            <img
              src={project1}
              alt="project1"
              id="projectimage"
              style={{ width: "100%" }}
            />
            <button id="readMore" onClick={() => showProject(1)}>
              {lenguaje == "eng" ? "See More" : "Ver Más"}
            </button>
          </div>
        </div>
        <div className="card" style={{ "--i": 0 }}>
          <div className="content" style={{ "--j": 2 }}>
            <h2>Project 02</h2>
            <p>
              Vestibulum urna risus, molestie venenatis mauris vitae, semper
              ornare urna. Nulla ac est sem. Vivamus lacinia odio in ante
              imperdiet convallis.
            </p>
            <a href="">{lenguaje == "eng" ? "Read More" : "Leer Más"}</a>
          </div>
        </div>
        <div className="card" style={{ "--i": 1 }}>
          <div className="content" style={{ "--j": 3 }}>
            <h2>Project 03</h2>
            <p>
              Vivamus quam ligula, commodo sed porta non, tincidunt nec libero.
              Proin faucibus, risus eget placerat pellentesque, elit lorem
              consectetur quam.
            </p>
            <a href="">{lenguaje == "eng" ? "Read More" : "Leer Más"}</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
